import { QueryClient } from "@tanstack/react-query";

/**
 * Shared TanStack Query client. staleTime mirrors the old Streamlit
 * @st.cache_data TTL (5 min); writes invalidate the relevant keys.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
